import { REVIEW_FIELDS } from '../constants/common';

const FIELDS_ACTION_TEXT: { [key in REVIEW_FIELDS]?: string } = {
  [REVIEW_FIELDS.LOCATION_GAR_ID]: 'региона',
  [REVIEW_FIELDS.ORGANIZATION_TYPE]: 'типа организации',
  [REVIEW_FIELDS.PRODUCT_ID]: 'продукта',
  [REVIEW_FIELDS.ORGANIZATION_ID]: 'организации',
  [REVIEW_FIELDS.SERVICE]: 'услуги',
  [REVIEW_FIELDS.IS_LEGAL]: 'услуги|Физ или юр лицо',
  [REVIEW_FIELDS.RATING]: 'оценки',
  [REVIEW_FIELDS.TITLE]: 'темы отзыва',
  [REVIEW_FIELDS.TEXT]: 'текста отзыва',
  // блок доп информации
  [REVIEW_FIELDS.BIRTHDAY]: 'доп информации|Дата рождения',
  [REVIEW_FIELDS.USER_NAME]: 'доп информации|ФИО',
  [REVIEW_FIELDS.USER_PHONE]: 'доп информации|Телефон',
  [REVIEW_FIELDS.MESSAGE_FOR_COMPANY]: 'доп информации|Подробности',
};

export const EVENT_ACTIONS = {
  UPDATE: 'Сохранить изменения',
  SUBMIT: 'Опубликовать',
  UPLOAD_DOCUMENT: ['Заполнение доп информации', 'Загрузка документов'],
  REMOVE_DOCUMENT: ['Заполнение доп информации', 'Удаление документов'],
  CHANGE_REVIEW: 'Изменить отзыв',
  GET_CODE: ['Авторизация', 'Запрос кода'],
};

export const REVIEW_FIELD_TO_ACTION_LABEL_MAP = (fieldName: REVIEW_FIELDS, isEdit: boolean) => {
  const action = isEdit ? 'Изменение' : 'Заполнение';

  return `${action} ${FIELDS_ACTION_TEXT[fieldName]}`;
};
